module.exports = __webpack_public_path__ + "static/img/logo1.32028f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/logo1.png
// module id = UWxg
// module chunks = 12